import React from 'react';
import { connect } from 'react-redux';
import {
  IonCardContent,
  IonSegment,
  IonSegmentButton,
  IonIcon,
  IonLabel,
  IonDatetime,
  IonItem,
  IonTextarea,
  IonModal,
} from '@ionic/react';
import {
  heartOutline, heart, checkbox, 
  clipboard, squareOutline,
} from 'ionicons/icons';
import { RootState, actions } from '../store';
import Notes from './Notes';
import { Place } from '../store/places/types';
import { Token } from '../store/users/types';

type Props = typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  parkCode: string,
  park: any,
  userParks?: any,
  tokens: any,
  isLoggedIn: boolean,
};

class ActionButtons extends React.Component<Props> {
  state = {
    timer: setTimeout(() => {}, 2000),
    notes: '',
    showNotesModal: false,
  }
  constructor(props: Props) {
    super(props);
    const { myList, park } = this.props;
    const notes = myList[park.parkCode] ? myList[park.parkCode].notes : '';
    this.state = {
      ...this.state,
      notes,
    };
  }
  openNotes = () => {
    this.setState(() => ({
      showNotesModal: true
    }));
  };

  closeNotes = () => {
    this.setState(() => ({
      showNotesModal: false
    }));
  };

  toggleVisitedPlace = () => {
    const { myList, park, isLoggedIn, userParks, tokens } = this.props;
    if (isLoggedIn) {
      const currentPark = userParks[park.parkCode];
      const isVisited = currentPark && !!currentPark.visited;
      if (isVisited) {
        this.props.removeFromUserList(tokens, park.parkCode, 'visited');
        return;
      }
      this.props.addToUserList(tokens, {
        visited_on: new Date().getTime(),
        park_code: park.parkCode,
        park_name: park.parkName,
      }, 'visited');
      return;
    }
    const tags = myList[park.parkCode] ? myList[park.parkCode].tags : [];
    const parkTags = tags || [];
    const isVisited = parkTags.includes('visited');
    if (isVisited) {
      this.props.removeFromVisitedPlaces(myList, park);
      // this.props.removeDateFromPark(myList, park);
      return;
    }
    this.props.addToVisitedPlaces(myList, park);
  }

  toggleBucketList = () => {
    const { myList, park, isLoggedIn, userParks, tokens } = this.props;
    if (isLoggedIn) {
      const currentPark = userParks[park.parkCode];
      const isBucket = currentPark && !!currentPark.bucket;
      if (isBucket) {
        this.props.removeFromUserList(tokens, park.parkCode, 'bucket');
        return;
      }
      this.props.addToUserList(tokens,{
        park_code: park.parkCode,
        park_name: park.parkName,
      }, 'bucket');
      return;
    }
    const tags = myList[park.parkCode] ? myList[park.parkCode].tags : [];
    const parkTags = tags || [];
    const isBucketList = parkTags.includes('bucket');
    if (isBucketList) {
      this.props.removeFromBucketList(myList, park);
      return;
    }
    this.props.addToBucketList(myList, park);
  }

  toggleFavorite = () => {
    const { myList, park, isLoggedIn, userParks, tokens } = this.props;
    if (isLoggedIn) {
      const currentPark = userParks[park.parkCode];
      const isFavorited = currentPark && !!currentPark.favorites;
      if (isFavorited) {
        this.props.removeFromUserList(tokens, park.parkCode, 'favorites');
        return;
      }
      this.props.addToUserList(tokens, {
        park_code: park.parkCode,
        park_name: park.parkName,
      }, 'favorites');
      return;
    }
    const tags = myList[park.parkCode] ? myList[park.parkCode].tags : [];
    const parkTags = tags || [];
    const isFavorite = parkTags.includes('favorites');
    if (isFavorite) {
      this.props.removeFromFavorites(myList, park);
      return;
    }
    this.props.addToFavorites(myList, park);
  }

  // updateNote = (e: CustomEvent) => {
  //   const data = e.detail.value;
  //   const { myList, park } = this.props;
  //   if (this.state.timer !== null) {
  //     clearTimeout(this.state.timer);
  //   }
  //   const timerTimeout = setTimeout(async () => {
  //     this.props.updateNote(myList, park, data);
  //     this.setState({
  //       ...this.state,
  //       notes: data,
  //     });
  //   }, 2000);
  //   this.setState({
  //     ...this.state,
  //     timer: timerTimeout,
  //     notes: data,
  //   });
  // }

  updateNotes = (data: string) => {
    const { myList, park, isLoggedIn, tokens } = this.props;
    if (isLoggedIn) {
      this.props.addNotes(tokens, {
        park_code: park.parkCode,
        park_name: park.name,
        notes: data,
      });
      return;
    }
    this.props.updateNote(myList, park, data);
  }
  setDate = (e: CustomEvent) => {
    const { myList, userParks, park, isLoggedIn, tokens } = this.props;
    const { parkCode } = park;
    const newDate = new Date(e.detail.value).getTime();
    if (isLoggedIn) {
      const currentPark = userParks[parkCode];
      const visited = currentPark && currentPark.visited && currentPark.visited.visited_on
      if (visited && visited.toString() === newDate.toString()) {
        return;
      }
      this.props.updateDate(tokens, {
        park_code: parkCode,
        park_name: park.name,
        visited_on: newDate,
      });
      return;
    }
    const date = myList[parkCode] ? myList[parkCode].date : ''
    if (date && date.toString() === newDate.toString()) {
      return;
    }
    this.props.addDateToPark(myList, park, newDate);
  }
  render() {
    const { myList, park, userParks, isLoggedIn } = this.props;
    let notes;
    let isVisited;
    let isFavorited;
    let isBucketList;
    let date;
    if (!isLoggedIn) {
      const tags = myList[park.parkCode] ? myList[park.parkCode].tags : [];
      date = myList[park.parkCode] ? myList[park.parkCode].date : '';
      notes = myList[park.parkCode] ? myList[park.parkCode].notes : '';
      const parkTags = tags || [];
      isVisited = parkTags.includes('visited');
      isFavorited = parkTags.includes('favorites');
      isBucketList = parkTags.includes('bucket');
    } else {
      const currentPark = userParks[park.parkCode];
      if (currentPark) {
        date = currentPark.visited && currentPark.visited.visited_on;
        date = date && new Date(currentPark.visited.visited_on).toLocaleDateString();
        notes = currentPark.notes && currentPark.notes.notes;
        isVisited = !!currentPark.visited;
        isFavorited = !!currentPark.favorites;
        isBucketList = !!currentPark.bucket;
      }
    }
    const placeholderText = isVisited ? 'Select a date' : 'N/A';
    const name = park.name || '';
    return (
      <IonCardContent>
        <IonSegment className="park-buttons" color="light">
          <IonSegmentButton
            onClick={this.toggleVisitedPlace}>
            <IonIcon
              color={isVisited ? "primary" : "dark"}
              icon={isVisited ? checkbox : squareOutline} />
            <IonLabel color="dark">Visited</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton
            onClick={this.toggleFavorite}>
            <IonIcon
              color={isFavorited ? "danger" : "dark"}
              icon={isFavorited ? heart : heartOutline} />
            <IonLabel color="dark">Favorite</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton
            onClick={this.toggleBucketList}>
            <IonIcon
              color={isBucketList ? "secondary" : "dark"}
              icon={isBucketList ? clipboard : clipboard} />
            <IonLabel color="dark">Bucket</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        <IonItem>
          <IonLabel><b>Date:</b></IonLabel>
          <IonDatetime
            onIonChange={this.setDate}
            disabled={!isVisited}
            displayFormat="MM/DD/YYYY"
            value={date}
            placeholder={placeholderText} />
        </IonItem>
        <IonItem onClick={this.openNotes}>
          <IonLabel><b>Notes:</b></IonLabel>
          <IonTextarea value={notes} placeholder="Add your notes here..." />
          {/* <IonTextarea value={this.state.notes} placeholder="Add your notes here..." /> */}
        </IonItem>
        <IonModal
          isOpen={this.state.showNotesModal}
          onDidDismiss={this.closeNotes}
        >
          <Notes
            value={notes}
            name={name}
            notesHandler={this.updateNotes}
            closeNotes={this.closeNotes}
          />
        </IonModal>
      </IonCardContent>
    )
  }
};

const mapStateToProps = (state: RootState) => ({
  myList: state.places.myList,
  // places: state.places.places,
});

const mapDispatchToProps = {
  updateNote: (places: Place[], place: Place, notes: string) => actions.places.updateParkNotes(places, place, notes),
  addDateToPark: (places: Place[], place: Place, date: any) => actions.places.addDateToPark(places, place, date),
  removeDateFromPark: (places: Place[], place: Place) => actions.places.removeDateFromPark(places, place),
  addToFavorites: (places: Place[], place: Place) => actions.places.addToFavoritesList(places, place),
  removeFromFavorites: (places: Place[], place: Place) => actions.places.removeFromFavoritesList(places, place),
  addToVisitedPlaces: (places: Place[], place: Place) => actions.places.addToVisitedPlaces(places, place),
  removeFromVisitedPlaces: (places: Place[], place: Place) => actions.places.removeFromVisitedPlaces(places, place),
  addToBucketList: (places: Place[], place: Place) => actions.places.addToBucketList(places, place),
  removeFromBucketList: (places: Place[], place: Place) => actions.places.removeFromBucketList(places, place),
  addToUserList: (tokens: Token, parkData: any, listType: string) => actions.users.addToUserList(tokens, parkData, listType),
  removeFromUserList: (tokens: Token, parkCode: string, listType: string) => actions.users.removeFromUserList(tokens, parkCode, listType),
  addNotes: (tokens: Token, parkData: any) => actions.users.addNotes(tokens, parkData),
  updateDate: (tokens: Token, parkData: any) => actions.users.updateDate(tokens, parkData),
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionButtons);
